import { useSelector } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { hasRole, checkActivationBySlug } from '../../utils/utilityFuncs'
import PrivateRoute from './PrivateRoute'

// Device Manager is only relevant when user has exolab or virtual-exolab activated (or is admin)
export const DeviceManagerRoute = ({ ...rest }) => {
  const { roles } = useSelector(state => state.auth.user)
  const { enableStudentLedExoLabs, activations } = useSelector(state => state.initial) || {}

  const isStudent = hasRole(['student'], roles)
  const isAdmin = hasRole(['superadmin', 'district-admin'], roles)
  const hasExolabActivated = isAdmin || checkActivationBySlug('exolab', activations)
  const hasVirtualExolabActivated = isAdmin || checkActivationBySlug('virtual-exolab', activations)
  const canAccessDeviceManager = hasExolabActivated || hasVirtualExolabActivated

  if (!canAccessDeviceManager) {
    return <Redirect to="/" />
  }

  const allowedRoles = ['teacher']
  if (isStudent && enableStudentLedExoLabs) {
    allowedRoles.push('student')
  }

  return (
    <PrivateRoute
      allowedRoles={allowedRoles}
      {...rest}
    />
  )
}
